import React, { useEffect, useState, useRef } from "react";
import Loader from "../../../Utils/Loader";
import {
  getAdminOpenPosition,
  updateTargetAndStoploss,
} from "../../../Service/admin.service";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import DeltaSocketClient from "../../../Utils/main/DeltaSocket";
import { TRADE_EXECUTE } from "../../../Service/user.service";
import toast from "react-hot-toast";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";
import { getOpenOrders, deleteOrder } from "../../../Service/admin.service";
import { EditOpenOrderPrice } from "../../../Service/user.service";
import Swal from "sweetalert2";
import { usePrices } from "../../../context/PriceContext";

const safeFormatDateTime = (value) => {
  try {
    return value ? fDateTimeSuffix(value) : "—";
  } catch {
    return "—";
  }
};

const Tradinghistory = ({ change, onChange }) => {
  const token = JSON.parse(localStorage.getItem("user_details"))?.token;
  const prices = usePrices();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [tradeUpdates, setTradeUpdates] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [activeTab, setActiveTab] = useState("all");
  const [ordersData, setOrdersData] = useState({ loading: true, data: [] });
 
  
  const [editingPriceId, setEditingPriceId] = useState(null);
  const [editPriceValue, setEditPriceValue] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);
  const [editableRows, setEditableRows] = useState({});
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [pendingUpdates, setPendingUpdates] = useState({});


  // Auto-decimal rounding based on value size
  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2; // No decimals for big numbers
    } else if (Math.abs(value) >= 1) {
      digits = 2; // 2 decimals for normal numbers
    } else if (Math.abs(value) >= 0.01) {
      digits = 4; // 4 decimals for small numbers
    } else {
      digits = 8; // 8 decimals for very tiny values
    }

    return Number(value.toFixed(digits));
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "-";
    return Number(value).toFixed(3);
  };


  const fetchTradeHistory = async () => {
    try {
      const response = await getAdminOpenPosition({
        fromDate,
        toDate,
      });

      if (response?.status) {
        let Order_data =
          response.data?.filter(
            (order) => order.platform === "PANEL" && order.usertype === "ADMIN"
          ) || [];

        setTradeHistoryData(Order_data);


        onChange && onChange(response?.data && response?.data[0]);

        // Initialize tradeUpdates with existing values
        const initialUpdates = {};
        (Order_data || []).forEach((trade) => {
          initialUpdates[trade._id] = {
            target: trade.target || "",
            stoploss: trade.stoploss || "",
            exit_Time: trade.exit_Time || "",
          };
        });
        setTradeUpdates(initialUpdates);
      } else {
        setTradeHistoryData([]);

      }
    } catch (err) {
      setTradeHistoryData([]);

    } finally {
      setLoading(false);
    }
  };

  const handlePriceEdit = (orderId, currentPrice) => {
    setEditingPriceId(orderId);
    setEditPriceValue(currentPrice ? currentPrice.toString() : "");
  };

  const handleCancelEdit = () => {
    setEditingPriceId(null);
    setEditPriceValue("");
  };
  const handleDeleteOrder = async (orderId) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteOrder({ orderId });
          if (response?.status) {
            Swal.fire("Deleted!", "Your order has been deleted.", "success");
            setRefresh((prev) => !prev);
          } else {
            console.error("Failed to delete order:", response?.message);
          }
        } else {
          Swal.fire("Cancelled", "Your order is safe :)", "error");
        }
      });
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };
  const fetchOpenOrders = async () => {
    try {
      const response = await getOpenOrders({ role: "ADMIN" });
      if (response?.status) {
        setOrdersData({ loading: false, data: response.data });

      } else {
        setOrdersData({ loading: false, data: [] });
      }
    } catch (err) {
      setOrdersData({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    setOrdersData((prev) => ({ ...prev, loading: true }));
    if (activeTab === "all") fetchTradeHistory();
    else if (activeTab === "open") fetchOpenOrders();
  }, [activeTab, refresh, change]);

  // Validation function
  const validateTradeValue = (row, fieldName, value) => {
    const livePrice = prices?.[row.symbol]?.spot_price || row.entryPrice;
    const entryPrice = parseFloat(row.entryPrice);
    const numValue = parseFloat(value);

    if (!value || isNaN(numValue)) {
      return ""; // No error for empty values
    }

    const errors = [];

    if (fieldName === "target") {
      if (row.side === "BUY") {
        if (numValue <= livePrice) {
          errors.push(
            `Target should be greater than current price (${livePrice})`
          );
        }
        if (numValue <= entryPrice) {
          errors.push(
            `Target should be greater than entry price (${entryPrice})`
          );
        }
      } else if (row.side === "SELL") {
        if (numValue >= livePrice) {
          errors.push(
            `Target should be less than current price (${livePrice})`
          );
        }
        if (numValue >= entryPrice) {
          errors.push(`Target should be less than entry price (${entryPrice})`);
        }
      }
    }

    if (fieldName === "stoploss") {
      if (row.side === "BUY") {
        if (numValue >= livePrice) {
          errors.push(
            `Stop Loss should be less than current price (${livePrice})`
          );
        }
        if (numValue >= entryPrice && livePrice < entryPrice) {
          errors.push(
            `Stop Loss should be less than entry price (${entryPrice})`
          );
        }
      } else if (row.side === "SELL") {
        if (numValue <= livePrice) {
          errors.push(
            `Stop Loss should be greater than current price (${livePrice})`
          );
        }
        if (numValue <= entryPrice) {
          errors.push(
            `Stop Loss should be greater than entry price (${entryPrice})`
          );
        }
      }
    }

    if (fieldName === "exitTime") {
      const now = new Date();
      const exitTime = new Date(value);

      if (isNaN(exitTime.getTime())) {
        errors.push("Invalid date format");
      } else if (exitTime <= now) {
        errors.push("Exit time should be in the future");
      }
    }

    return errors.join(". ");
  };

  const handleOnChange = (row, e) => {
    const { name, value } = e.target;

    if (!row._id) return;

    // Update the trade values
    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: {
        ...prev[row._id],
        [name]: value,
      },
    }));

    // Validate the input
    const errorKey = `${row._id}-${name}`;
    const errorMessage = validateTradeValue(row, name, value);

    setValidationErrors((prev) => ({
      ...prev,
      [errorKey]: errorMessage,
    }));
  };

  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    const hasError = validationErrors[errorKey];
    return `form-control form-control-sm ${hasError ? "is-invalid" : ""}`;
  };

  const getFieldValue = (row, fieldName) => {
    if (fieldName === "exit_Time") {
      return tradeUpdates[row._id]?.exitTime || row.exit_Time || "";
    }
    return tradeUpdates[row._id]?.[fieldName] || "";
  };

  const handleSaveOpenOrder = async (row) => {
    const updates = pendingUpdates[row._id];

    // Validate that at least one field is filled
    if (!updates?.price && !updates?.target && !updates?.stoploss) {
      toast.error("Please enter at least Price, Target, or Stoploss");
      return;
    }

    setUpdateLoading(true);

    try {
      const requestData = {
        _id: row._id,
        ...(updates.price && { price: parseFloat(updates.price) }),
        ...(updates.target && { target: parseFloat(updates.target) }),
        ...(updates.stoploss && { stoploss: parseFloat(updates.stoploss) }),
      };

      const response = await EditOpenOrderPrice(requestData, token);

      if (response?.status) {
        // Update local state
        setOrdersData((prevState) => ({
          ...prevState,
          data: prevState.data.map((order) =>
            order._id === row._id
              ? {
                ...order,
                price: updates.price ? parseFloat(updates.price) : order.price,
                target: updates.target ? parseFloat(updates.target) : order.target,
                stoploss: updates.stoploss ? parseFloat(updates.stoploss) : order.stoploss,
              }
              : order
          ),
        }));

        // Clear editing state
        setEditingPriceId(null);
        setPendingUpdates(prev => {
          const newState = { ...prev };
          delete newState[row._id];
          return newState;
        });

        toast.success("Order updated successfully!");
      } else {
        toast.error(response?.message || "Failed to update order");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(`Network Error: ${error.message || "Please try again"}`);
    } finally {
      setUpdateLoading(false);
    }
  };

  const calculatePnL = (row) => {
    const permissions = JSON.parse(localStorage.getItem("permission"));

    const livePrice = prices?.[row.symbol]?.spot_price;
    const entryPrice = parseFloat(row.entryPrice);
    const quantity = parseFloat(row.quantity);

    if (!livePrice || !entryPrice || !quantity) return null;

    let pnl = 0;

    // Normal PnL Logic
    if (row.side === "BUY") {
      pnl = (livePrice - entryPrice) * quantity;
    } else if (row.side === "SELL") {
      pnl = (entryPrice - livePrice) * quantity;
    }

    // Delta Exchange Special Conversion
    if (permissions?.trade_History_DeltaExchange == 1) {
      if (row.symbol === "BTCUSD") {
        pnl = pnl / 1000;
      } else if (row.symbol === "ETHUSD") {
        pnl = pnl / 100;
      }
    }

    return pnl;
  };

  // const handleUpdateRow = async (row) => {
  //   try {
  //     const target = tradeUpdates[row._id]?.target;
  //     const stoploss = tradeUpdates[row._id]?.stoploss;
  //     const exitTime = tradeUpdates[row._id]?.exitTime;

  //     if (!target && !stoploss && !exitTime) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Please fill at least Target, Stoploss or Exit Time!",
  //       });
  //       return;
  //     }

  //     const payload = {
  //       tradeId: row._id,
  //       target,
  //       stoploss,
  //       exitTime, // 🔥 अब exit time भी API में भेजेगा
  //     };

  //     const response = await updateTargetAndStoploss(payload);

  //     if (response?.status) {
  //       toast.success("Updated successfully");

  //       fetchTradeHistory();
  //       setEditableRows((prev) => ({ ...prev, [row._id]: false }));
  //     } else {
  //       toast.error(response?.message || "Update failed ❌");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Something went wrong ❌");
  //   }
  // };

  const handleUpdateRow = async (row) => {
    try {
      const target = tradeUpdates[row._id]?.target;
      const stoploss = tradeUpdates[row._id]?.stoploss;
      const exitTime = tradeUpdates[row._id]?.exitTime;

      const entryPrice = Number(row.entryPrice);
      const t = target ? Number(target) : null;
      const sl = stoploss ? Number(stoploss) : null;

      if (!target && !stoploss && !exitTime) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill at least Target, Stoploss or Exit Time!",
        });
        return;
      }

      /* ================= ENTRY PRICE BASED VALIDATION ================= */

      // 🟢 BUY
      if (row.side === "BUY") {
        if (t !== null && t <= entryPrice) {
          Swal.fire(
            "Invalid Target",
            `BUY Target must be greater than Entry Price (${entryPrice})`,
            "error"
          );
          return;
        }

        if (sl !== null && sl >= entryPrice) {
          Swal.fire(
            "Invalid Stoploss",
            `BUY Stoploss must be less than Entry Price (${entryPrice})`,
            "error"
          );
          return;
        }
      }

      // 🔴 SELL
      if (row.side === "SELL") {
        if (t !== null && t >= entryPrice) {
          Swal.fire(
            "Invalid Target",
            `SELL Target must be less than Entry Price (${entryPrice})`,
            "error"
          );
          return;
        }

        if (sl !== null && sl <= entryPrice) {
          Swal.fire(
            "Invalid Stoploss",
            `SELL Stoploss must be greater than Entry Price (${entryPrice})`,
            "error"
          );
          return;
        }
      }

      /* ================= API CALL ================= */

      const payload = {
        tradeId: row._id,
        target,
        stoploss,
        exitTime,
      };

      const response = await updateTargetAndStoploss(payload);

      if (response?.status) {
        toast.success("Updated successfully");
        fetchTradeHistory();
        setEditableRows((prev) => ({ ...prev, [row._id]: false }));
      } else {
        toast.error(response?.message || "Update failed ❌");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong ❌");
    }
  };



  const columns = [
    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "190px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "130px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="bg-success text-white rounded p-1">BUY ENTRY</span>
        ) : (
          <span className="bg-danger text-white rounded p-1">SELL ENTRY</span>
        ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Entry Price",
      selector: (row) =>
        row.entryPrice !== null ? formatPrice(row.entryPrice) : "-",
      sortable: true,
      width: "140px",
    },

    {
      name: "Live Price",
      selector: (row) => {
        const price = prices?.[row.symbol]?.spot_price || row.exitPrice;
        return price !== null ? (
          roundSmart(parseFloat(price)) || (
            <div
              className="spinner-border spinner-border-sm text-success"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )
        ) : (
          <div
            className="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        );
      },
      sortable: true,
      width: "130px",
    },
    {
      name: "P/L",
      selector: (row) => calculatePnL(row),
      cell: (row) => {
        const pnl = calculatePnL(row);

        if (pnl === null) return <span style={{ color: "gray" }}>-</span>;

        const pnlColor = pnl >= 0 ? "green" : "red";
        return <span style={{ color: pnlColor }}>{roundSmart(pnl)}</span>;
      },
    },

    {
      name: user_details?.broker === "2" ? "Lot" : "Quantity",
      selector: (row) =>
        row.quantity !== null ? parseFloat(row.quantity) : "-",
      sortable: true,
      width: "120px",
    },
    {
      name: "Target",
      selector: (row) => row.target,
      cell: (row) => (
        <input
          type="number"
          name="target"
          value={getFieldValue(row, "target") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "target")}
          placeholder="Target"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Stop Loss",
      selector: (row) => row.stoploss,
      cell: (row) => (
        <input
          type="number"
          name="stoploss"
          value={getFieldValue(row, "stoploss") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "stoploss")}
          placeholder="Stop Loss"
          step="0.01"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Exit Time",
      selector: (row) => row.exit_Time,
      cell: (row) => {
        const errorKey = `${row._id}-exitTime`;
        const hasError = validationErrors[errorKey];

        return (
          <div className="position-relative">
            <input
              type="datetime-local"
              name="exitTime"
              value={
                tradeUpdates[row._id]?.exitTime
                  ? formatDateForInput(tradeUpdates[row._id].exitTime)
                  : row.exit_Time
                    ? formatDateForInput(row.exit_Time)
                    : ""
              }
              onChange={(e) => handleOnChange(row, e)}
              className={getInputClassName(row, "exitTime")}
              min={new Date().toISOString().slice(0, 16)}
              disabled={!editableRows[row._id]} // 🔥 अब editable
            />

            {hasError && (
              <div className="invalid-tooltip" style={{ display: "block" }}>
                {hasError}
              </div>
            )}
          </div>
        );
      },
      sortable: true,
      width: "240px",
    },
    {
      name: "Action",
      cell: (row) => {
        if (row.usertype == "ADMIN" && row.platform == "PANEL") {
          const isEditable = editableRows[row._id];

          return (
            <div className="d-flex gap-2">
              {isEditable ? (
                <>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleUpdateRow(row)}
                  >
                    Confirm
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() =>
                      setEditableRows((prev) => ({ ...prev, [row._id]: false }))
                    }
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() =>
                    setEditableRows((prev) => ({ ...prev, [row._id]: true }))
                  }
                  disabled={row.extstatus !== "ACTIVE"}
                >
                  {row.extstatus == "ACTIVE" ? "Edit" : "Close"}
                </button>
              )}
            </div>
          );
        }
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },

    {
      name: "🚪 Square Off",
      cell: (row) => (
        <button
          className="btn btn-outline-danger btn-sm fw-bold"
          disabled={row.extstatus !== "ACTIVE"}
          onClick={() => handleSquareOff(row)}
          style={{
            opacity: row.extstatus === "ACTIVE" ? 1 : 0.5,
            cursor: row.extstatus === "ACTIVE" ? "pointer" : "not-allowed",
            borderRadius: "6px",
            padding: "4px 12px",
            minWidth: "100px",
          }}
          title={
            row.extstatus !== "ACTIVE"
              ? "Trade already closed"
              : "Square Off this trade"
          }
        >
          Square Off
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },
  ];


  const columns1 = [
    {
      name: "Order Date",
      selector: (row) => row.createdAt,
      cell: (row) => <div>{safeFormatDateTime(row.createdAt)}</div>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      cell: (row) => <div>{row.symbol || "-"}</div>,
      sortable: true,
      width: "110px",
    },

    {
      name: "Live Price",
      selector: (row) => {
        const price = prices?.[row.symbol]?.spot_price;
        return price !== null ? (
          roundSmart(parseFloat(price)) || (
            <div className="spinner-border spinner-border-sm text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )
        ) : (
          <div className="spinner-border spinner-border-sm text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        );
      },
      sortable: true,
      width: "130px",
    },

    {
      name: "Price",
      selector: (row) => row.price,
      cell: (row) => {
        const isEditing = editingPriceId === row._id;

        return isEditing ? (
          <input
            type="number"
            value={pendingUpdates[row._id]?.price ?? row.price ?? ""}
            onChange={(e) =>
              setPendingUpdates(prev => ({
                ...prev,
                [row._id]: {
                  ...prev[row._id],
                  price: e.target.value
                }
              }))
            }
            className="form-control form-control-sm"
            placeholder="Price"
            step="0.01"
          />
        ) : (
          <div className="d-flex align-items-center gap-2">
            <span>{row.price || "-"}</span>
            {row.usertype === "ADMIN" && row.platform === "PANEL" && (
              <button
                className="btn btn-outline-primary btn-sm p-1"
                onClick={() => setEditingPriceId(row._id)}
                style={{ fontSize: "12px" }}
              >
                <i className="bi bi-pencil"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "130px",
    },
    {
      name: "Target",
      cell: (row) => {
        const isEditing = editingPriceId === row._id;

        return isEditing ? (
          <input
            type="number"
            value={pendingUpdates[row._id]?.target ?? row.target ?? ""}
            onChange={(e) =>
              setPendingUpdates(prev => ({
                ...prev,
                [row._id]: {
                  ...prev[row._id],
                  target: e.target.value
                }
              }))
            }
            className="form-control form-control-sm"
            placeholder="Target"
            step="0.01"
          />
        ) : (
          <span>{row.target || "-"}</span>
        );
      },
      width: "130px",
    },
    {
      name: "Stoploss",
      cell: (row) => {
        const isEditing = editingPriceId === row._id;

        return isEditing ? (
          <input
            type="number"
            value={pendingUpdates[row._id]?.stoploss ?? row.stoploss ?? ""}
            onChange={(e) =>
              setPendingUpdates(prev => ({
                ...prev,
                [row._id]: {
                  ...prev[row._id],
                  stoploss: e.target.value
                }
              }))
            }
            className="form-control form-control-sm"
            placeholder="Stoploss"
            step="0.01"
          />
        ) : (
          <span>{row.stoploss || "-"}</span>
        );
      },
      width: "130px",
    },
    {
      name: "Actions",
      cell: (row) => {
        const isEditing = editingPriceId === row._id;

        return (
          <div className="d-flex gap-2 align-items-center">
            {isEditing ? (
              <>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => handleSaveOpenOrder(row)}
                  disabled={updateLoading}
                >
                  {updateLoading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    <i className="bi bi-check"></i>
                  )}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setEditingPriceId(null);
                    setPendingUpdates(prev => {
                      const newState = { ...prev };
                      delete newState[row._id];
                      return newState;
                    });
                  }}
                  disabled={updateLoading}
                >
                  <i className="bi bi-x"></i>
                </button>
              </>
            ) : (
              row.usertype === "ADMIN" && row.platform === "PANEL" && (
                <i
                  className="fa fa-trash text-danger"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                  onClick={() => handleDeleteOrder(row._id)}
                ></i>
              )
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },

    {
      name: "Strategy",
      selector: (row) => row.strategy,
      cell: (row) => <div>{row.strategy || "-"}</div>,
      sortable: true,
      width: "120px",
    },
    {
      name: "User Type",
      selector: (row) => row.usertype,
      cell: (row) =>
        row?.usertype === "USER" ? row.username || "USER" : row?.usertype || "ADMIN",
      sortable: true,
      width: "130px",
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => row?.platform || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "Market Type",
      selector: (row) => row.market_type,
      cell: (row) => row?.market_type || "-",
      sortable: true,
      width: "130px",
    },

  ];

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };

  const UpdateTargetAndStoplossApi = async () => {
    try {
      // Check if there are any validation errors
      const hasErrors = Object.values(validationErrors).some((error) => error);
      if (hasErrors) {
        toast.error("Please fix all validation errors before applying changes");
        return;
      }

      // Get only the trades that have been modified
      const modifiedTrades = Object.entries(tradeUpdates).filter(
        ([tradeId, updates]) => {
          const originalTrade = tradeHistoryData.find(
            (trade) => trade._id === tradeId
          );
          return (
            originalTrade &&
            (updates.target !== (originalTrade.target || "") ||
              updates.stoploss !== (originalTrade.stoploss || "") ||
              updates.exitTime !== (originalTrade.exitTime || ""))
          );
        }
      );

      if (modifiedTrades.length === 0) {
        toast.info("No changes to apply");
        return;
      }

      // Process each modified trade
      const updatePromises = modifiedTrades.map(async ([tradeId, updates]) => {
        return updateTargetAndStoploss({
          tradeId,
          target: updates.target,
          stoploss: updates.stoploss,
          exitTime: updates.exitTime,
        });
      });

      const results = await Promise.all(updatePromises);
      const successCount = results.filter((result) => result.status).length;

      if (successCount === modifiedTrades.length) {
        toast.success(`${successCount} trade(s) updated successfully`);
        fetchTradeHistory();
        setValidationErrors({});
      } else {
        toast.error(
          `${modifiedTrades.length - successCount} trade(s) failed to update`
        );
      }
    } catch (error) {
      console.error("Error updating trades:", error);
      toast.error("An error occurred while updating trades");
    }
  };



  // Handle square off (only for manual trades)
  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    try {
      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:100|price:${prices?.[row.symbol]?.spot_price}|strategy:${row?.strategy
        }|key:${row.key}|category:${row.category
        }|signalType:PANEL_SQUAREOFF|tradeid:${row._id}`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  return (
    <>
      <div className="filter-row row gx-3 gy-2 align-items-end mb-3">
        <div className="col-md-3 col-6">
          <label className="form-label mb-1">From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 col-6">
          <label className="form-label mb-2">To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 d-flex gap-2 col-4">
          <button
            className="btn btn-primary"
            onClick={() => setRefresh((prev) => !prev)}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>

        <div className="col-md-3 d-flex justify-content-end col-8">
          <button
            className="btn btn-sm btn-primary"
            onClick={UpdateTargetAndStoplossApi}
          >
            Apply Changes
            <i className="fa fa-check ms-1"></i>
          </button>
        </div>
      </div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "all" ? "active" : ""}`}
            onClick={() => setActiveTab("all")}
            style={{ cursor: "pointer" }}
          >
            All Orders
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "open" ? "active" : ""}`}
            onClick={() => setActiveTab("open")}
            style={{ cursor: "pointer" }}
          >
            Pending Orders
          </a>
        </li>
      </ul>

      <div className="mt-3">
        {activeTab === "all" ? (
          loading ? (
            <Loader />
          ) : (
            <Table columns={columns} data={tradeHistoryData || []} />
          )
        ) : activeTab === "open" ? (
          ordersData.loading ? (
            <Loader />
          ) : (
            <Table columns={columns1} data={ordersData.data || []} />
          )
        ) : null}
      </div>
    </>
  );
};

export default Tradinghistory;
